import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import { FaMap } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteVehicleGroup,
  fetchVehicleGroup,
} from "../../store/slices/thunk";
import GroupModal from "../../components/groupModal";
import "./Vehicle.scss";
import Loader from "../../components/loader";
import { useNavigate } from "react-router-dom";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";

const VehicleGroup = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllVehicleGroup, setAllVehicleGroup] = useState([]);
  const [page, setPage] = useState(1);
  const [groupModal, setGroupModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllVehicleGroup);
  const navigate = useNavigate()
  // const filteredData = getAllVehicleGroup.filter((vehicle:any) =>
  //   vehicle.name.toLowerCase().includes(search.toLowerCase())
  // );
  const DEBOUNCE_DELAY = 500; // milliseconds

  const ITEMS_PER_PAGE = 10;

  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  // const currentData = getAllVehicleGroup.slice(
  //   startIndex,
  //   startIndex + ITEMS_PER_PAGE
  // );
  // console.log("Current Data:", currentData);


useEffect(() => {
  const handler = setTimeout(async () => {
    setLoading(true);
try {
    const response = await dispatch(fetchVehicleGroup(page, ITEMS_PER_PAGE, search));
    if (
      response &&
      response?.data &&
      response?.data?.data?.length > 0 &&
      response?.isSuccess
    ) {
      setAllVehicleGroup(response?.data?.data);
      setTotalCount(response?.data?.totalCount);
    } else {
      setAllVehicleGroup([]);
    } } catch (error) {

    console.log(getAllVehicleGroup);
    } finally {
      setLoading(false);
    }
  }, DEBOUNCE_DELAY);

  // Clear timeout if search changes before delay finishes
  return () => clearTimeout(handler);
}, [dispatch, page, search]); // Include all relevant dependencies

  const handleGroupSave = async (data: any) => {
    console.log("Group Data received in parent:", data);

    try {
      const res: any = await dispatch(fetchVehicleGroup(page, 10, search));
      if (res?.data?.data) {
        setAllVehicleGroup(res?.data?.data);
        console.log("Updated Group List:", res?.data);
      } else {
        console.warn("No data received from fetchVehicleGroup.");
      }

      setGroupModal(false);
    } catch (error) {
      console.error("Error fetching group list:", error);
    }
  };

  const handledeleteVehicleGroupById = async (id: string) => {
    const response = await dispatch(deleteVehicleGroup(id));
    if (response && response.isSuccess) {
      const newDriver = getAllVehicleGroup.filter(
        (item: any) => item._id !== id
      );
      setAllVehicleGroup(newDriver);
    }
  };
  const navigateAddVehiclePage = async () => {
    navigate('/add-vehicle-group')
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Paper sx={{ padding: 2, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}> 
        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <div className="d-flex justify-content-between" style={{ flexShrink: 0 }}>
          <h3 className="" style={{fontWeight:"700"}}>Vehicle Group Management</h3>
          <button className="" onClick={() => setGroupModal(true)} style={{background:"#16a34a", color:"#fff", border:"none", borderRadius:"10px", textAlign:"center", alignItems:"center"}}
          
          >
          <GroupModal onSave={handleGroupSave} />
          </button>
          <button className=""  onClick={() => navigateAddVehiclePage()} style={{background:"#16a34a", color:"#fff", borderRadius:"10px", border:"none", width:"140px"}}>New Button</button>
           
         </div>
        <TableContainer sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
         
          <Table className="table mt-3">
            <TableHead className="th"> 
              <TableRow className="table-h-row">
  <TableCell
    className="table-cell"
    style={{ color: "#6b7280", background: "#f9fafb", fontSize: "18px", fontWeight: 500 }}
  >
    S.No
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#6b7280", background: "#f9fafb", fontSize: "18px", fontWeight: 500 }}
  >
    GROUP NAME
    <FilterPopover column="name" filterType="text" currentValue={filters.name || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#6b7280", background: "#f9fafb", fontSize: "18px", fontWeight: 500 }}
  >
    GROUP MEMBERS
    <FilterPopover column="description" filterType="text" currentValue={filters.description || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#6b7280", background: "#f9fafb", fontSize: "18px", fontWeight: 500 }}
  >
    VEHICLE NAMES
    <FilterPopover column="createdOn" filterType="text" currentValue={filters.createdOn || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#6b7280", background: "#f9fafb", fontSize: "18px", fontWeight: 500 }}
  >
    STATUS
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#6b7280", background: "#f9fafb", fontSize: "18px", fontWeight: 500 }}
  >
    Action
  </TableCell>
</TableRow>

            </TableHead>
             {loading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Loader/>
                </TableCell>
              </TableRow>
            ) : (

            <TableBody className="tb">
              {filteredData.map((vehicle: any, index) => (
                <TableRow className="t-row" key={index}>
                  <TableCell className="table-cell" style={{fontWeight:"100"}}>{index + 1}</TableCell>
                  <TableCell className="table-cell">
                    {vehicle.name || "--"}
                  </TableCell>
                  <TableCell className="table-cell">
                    {vehicle.description || "--"}
                  </TableCell>
                  <TableCell className="table-cell">
                    {vehicle.createdOn
                      ? new Date(vehicle.createdOn).toLocaleString("en-GB") // Format: DD/MM/YYYY, HH:MM:SS
                      : "--"}
                  </TableCell>
                 
                 <TableCell>
                  <button className="" style={{background:"#d1fae5", color:"#000", borderRadius:"10px", height:"25px", border:"none" }}>active</button>
                 </TableCell>

                  <TableCell className="table-cell">
                    <IconButton>
                      {/* <FaMap style={{ color: "#17a2b8" }} /> */}
                      <MdDelete
                        onClick={() =>
                          handledeleteVehicleGroupById(vehicle._id)
                        }
                        style={{ color: "red" }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {filteredData.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No Vehicle Group Found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            )}
          </Table>
        </TableContainer>
        </div>
          <nav style={{ flexShrink: 0 }}>
                    <ul className="pagination justify-content-center">
                      <li
                        className={`page-item ${
                          page === 1 && "disabled"
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            setPage((p) => Math.max(p - 1, 1))
                          }
                        >
                          Previous
                        </button>
                      </li>

                      {Array.from(
                        { length: Math.min(5, pageCount) },
                        (_, i) => (
                          <li
                            key={i + 1}
                            className={`page-item ${
                              page === i + 1 && "active"
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setPage(i + 1)}
                            >
                              {i + 1}
                            </button>
                          </li>
                        )
                      )}

                      {pageCount > 5 && (
                        <>
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                          <li className="page-item">
                            <button
                              className="page-link"
                              onClick={() => setPage(pageCount)}
                            >
                              {pageCount}
                            </button>
                          </li>
                        </>
                      )}

                      <li
                        className={`page-item ${
                          page === pageCount && "disabled"
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            setPage((p) => Math.min(p + 1, pageCount))
                          }
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
      </Paper>
    </div>
  );
};

export default VehicleGroup;

